module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAADgSURBVDhPpZM9CoQwEIUnC1tYia1X8AJ2nmMLwcKrWNrsVWz0GlaKIF7ATgtBnB11RNck+/vBI85k3iNiFEjAH1x4VdO2AHnOhYb5BFqCANGyuFCjD2ia+d1W3e/clNEHeN4ecL0iDgNvPKMOyLLdvCkMefMZdYBtywGzioIHdqh7Io5l4ybX5aEd6h7oe0RBV0Nl3pSmPLxCnQO+LxvOOn1W6jB1LQ/rFEVsopJXRMeRB19pmhYbPRFJIg+80+22WNefSQi+2F9SliCw6xCqCsAwuPsh4whgmhQwn+BnAB5UmDhVfPSw/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/transportation-node.png
// module id = 1002
// module chunks = 0